<template>
  <span style="word-break: break-word; max-width: 500px">
    <span v-if="IsJsonString() && checkAction()">
      <div class="d-flex flex-column justify-content-center">
        <div
          v-if="getUrl() != ''"
          class="d-flex justify-content-center my-2">
          <el-avatar
            :src="getUrl()"
            :size="100" />
        </div>
        <div
          class="mb-0 text-normal"
          style="white-space: pre-line">
          <div
            class="mb-0 text-normal"
            style="white-space: pre-line">
            <div v-if="isRtf" v-html="regexUrlFromText(titleMessage)"></div>
            <div
              class="fw-semibold"
              v-else-if="getUrl() != '' || isHightLight" v-html="regexUrlFromText(titleMessage)">
            </div>
            <div v-else>{{ JSON.parse(JSON.parse(this.content).params).msg.vi }}</div>
          </div>
        </div>
      </div>
    </span>
    <span
      v-else
      class="mb-0 text-normal"
      v-bind:class="messageRepied ? 'text-1-line-replied ' : ''"
      style="white-space: pre-line"
      v-bind:style="messageRepied ? 'word-break: break-word' : ''">
      <span
        id="regexText"
        @click="handleLinkClick"
        v-html="regexUrl(contentAfterHighlight)" />
    </span>
  </span>
</template>

<script>
import { removeVietnameseTones2 } from "../../lib/text-utils";

export default {
  props: ["content", "messageRepied", "mentions", "keyHighlight"],
  name: "ChatText",
  data() {
    return {
      listMentions: [],
    };
  },
  computed: {
    contentAfterHighlight() {
      if (!this.keyHighlight) return this.content;
      const normalizedText = removeVietnameseTones2(this.content.toLowerCase());
      const normalizedSearchKey = removeVietnameseTones2(this.keyHighlight.toLowerCase());

      const searchTerms = normalizedSearchKey.split(" ");

      let highlightedText = this.content;

      searchTerms.forEach((term) => {
        const regex = new RegExp(`(${term})`, "gi");
        normalizedText.replace(regex, (match) => {
          const start = normalizedText.indexOf(removeVietnameseTones2(match).toLowerCase());
          const originalMatch = this.content.substr(start, match.length);
          highlightedText = highlightedText.replace(
            new RegExp(`\\b${originalMatch}\\b`, "g"),
            `<span style="background-color: #DEB00C !important;">${originalMatch}</span>`
          );
          return match;
        });
      });

      return highlightedText;
    },
    titleMessage() {
      const contentMessage = JSON.parse(this.content);
      const message = contentMessage.title;

      let result = "";
      let currentIndex = 0;
      const styles = JSON.parse(contentMessage.params).styles;
      
      let currentList = null;
      let currentListItems = [];
      let mergedStyles = [];

      styles.sort((a, b) => {
        if (a.start === b.start) return b.len - a.len;
        return a.start - b.start; 
      });

      styles.forEach(({ start, len, st }) => {
        const styleEnd = start + len;
        let isMerged = false;
        let isList = st.includes("lst_1") || st.includes("lst_2");

        if (isList) {
          mergedStyles.push({
            start,
            len,
            styles: new Set(st.split(",")),
            children: [],
          });
        } else {
          mergedStyles.forEach((s) => {
            if (start >= s.start && styleEnd <= s.start + s.len) {
              s.styles = new Set([...s.styles, ...st.split(",")]);
              isMerged = true;
            }
          });

          if (!isMerged) {
            mergedStyles.push({
              start,
              len,
              styles: new Set(st.split(",")),
            });
          }
        }

        let parentList = mergedStyles
          .filter(
            (list) =>
              (list.styles.has("lst_1") || list.styles.has("lst_2")) &&
              start >= list.start &&
              !(list.start === start && list.len === len) &&
              styleEnd <= list.start + list.len
          )
          .sort((a, b) => b.start - a.start)[0];

        if (parentList) {
          parentList.children.push({
            start,
            len,
            styles: new Set(st.split(",")),
          });
        }
      });

      mergedStyles.forEach(({ start, len, styles, children }) => {
        const text = message.substring(start, start + len);

        if (currentIndex < start) {
          if (currentList && currentIndex < start - 1) {
            result += `${currentListItems.join("")}</${currentList}>`;
            currentList = null;
            currentListItems = [];
          }
          result += message.substring(currentIndex, start);
        }

        let styledText = text;
        let cssStyles = "";
        let listStyle = null;
        let indentation = "";

        styles.forEach((style) => {
          if (style === "b") cssStyles += "font-weight: bold; ";
          if (style === "i") cssStyles += "font-style: italic; ";
          if (style === "u") cssStyles += "text-decoration: underline; ";
          if (style === "s") cssStyles += "text-decoration: line-through; ";
          if (style.startsWith("f_")) cssStyles += `font-size: ${style.split("_")[1]}px; `;
          if (style.startsWith("c_")) cssStyles += `color: #${style.split("_")[1]}; `;
          if (style === "lst_1") {
            listStyle = "ul";
            cssStyles += "list-style-type: disc;";
          }
          if (style === "lst_2") {
            listStyle = "ol";
            cssStyles += "list-style-type: decimal;";
          }
          if (style.startsWith("ind_")) {
            indentation = `padding-left: ${style.split("_")[1]}px;`;
          }
        });

        if (cssStyles || indentation) {
          styledText = `<span style="${cssStyles} ${indentation}">${text}</span>`;
        }

        if (listStyle) {
          if (currentList !== listStyle) {
            if (currentList) {
              result += `${currentListItems.join("")}</${currentList}>`;
            }
            currentList = listStyle;
            currentListItems = [];
            result += `<${currentList} style="margin-left: 20px;">`;
          }

          let listItem = ``;

          if (children && children.length > 0) {
            listItem += `<li>`
            let prevEnd = start;
            children.forEach((child) => {
              const childStart = child.start;
              const childEnd = child.start + child.len;

              if (prevEnd < childStart) {
                const missingText = message.substring(prevEnd, childStart);
                listItem += `${missingText}`;
              }

              const childText = message.substring(childStart, childEnd);
              let childCss = "";

              child.styles.forEach((style) => {
                if (style === "b") childCss += "font-weight: bold; ";
                if (style === "i") childCss += "font-style: italic; ";
                if (style === "u") childCss += "text-decoration: underline; ";
                if (style === "s") childCss += "text-decoration: line-through; ";
                if (style.startsWith("f_")) childCss += `font-size: ${style.split("_")[1]}px; `;
                if (style.startsWith("c_")) childCss += `color: #${style.split("_")[1]}; `;
              });

              listItem += `<span style="${childCss}">${childText}</span>`;
              prevEnd = childEnd;
            });

            if (prevEnd < start + len) {
              const remainingText = message.substring(prevEnd, start + len);
              listItem += `${remainingText}`;
            }
            listItem += `</li>`
          } else {
            listItem = `<li>${styledText}</li>`;
          }
          currentListItems.push(listItem);
        } else {
          if (currentList) {
            result += `${currentListItems.join("")}</${currentList}>`;
            currentList = null;
            currentListItems = [];
          }
          result += styledText;
        }

        currentIndex = start + len;
      });

      if (currentList) {
        result += `${currentListItems.join("")}</${currentList}>`;
      }

      if (currentIndex < message.length) {
        result += message.substring(currentIndex);
      }

      return result;
    }
  },
  methods: {
    IsJsonString() {
      try {
        var json = JSON.parse(this.content);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    checkAction() {
      let con = JSON.parse(this.content);
      if (["msginfo.actionlist", "rtf"].includes(con.action)) {
        return true;
      }
      return false;
    },
    isRtf() {
      let con = JSON.parse(this.content);
      if (con.action != null && con.action === "rtf") return true;
      return false;
    },
    isHightLight() {
      let con = JSON.parse(this.content);
      let params = JSON.parse(con.params);
      return params.highLightsV2 != null && params.highLightsV2.length > 0;
    },
    getUrl() {
      let con = JSON.parse(this.content);
      let params = JSON.parse(con.params);
      if (params.avatarUrl && params.avatarUrl.length > 0) {
        return params.avatarUrl[0];
      }
      return "";
    },
    replace(instr, name, start, length) {
      let text = instr.substr(0, start) + name + instr.substr(start + length);
      return text;
    },

    convertToMentions(message) {
      let arr = [];
      let aliasInAccount = null;
      aliasInAccount = this.app.aliases.filter((s) => s.accountId === this.app.selectedConversation.accountId);
      if (aliasInAccount.length > 0 && this.listMentions.length > 0) {
        this.listMentions.reduce((pre, cur) => {
          let text = message.substr(pre, cur.pos - pre + cur.len);
          let item = this.app.aliases.find((s) => s.accountId === this.app.selectedConversation.accountId && s.id === cur.uid);
          if (item) {
            let name = "@" + item.name;
            let regexHtml = '<span class="pointer mb-0 text-link">' + name + "</span>";
            text = this.replace(text, regexHtml, cur.pos - pre, cur.len);
          } else {
            let regexHtml = '<span class="pointer mb-0 text-link">' + text.slice(cur.pos - pre, text.length) + "</span>";
            text = this.replace(text, regexHtml, cur.pos - pre, cur.len);
          }
          arr.push(text);
          return cur.pos + cur.len;
        }, 0);

        let item = this.listMentions[this.listMentions.length - 1];
        let text = message.substr(item.pos + item.len, message.length);
        arr.push(text);
      }
      return arr;
    },
    regexUrl(message) {
      if (this.keyHighlight) {
        return this.contentAfterHighlight;
      }
      let arr = this.convertToMentions(message);
      let urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      let newMess = message.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      let response = (arr.length > 0 ? arr.join("") : newMess).replace(urlRegex, function (url, b, c) {
        let url2 = c == "www." ? "http://" + url : url;
        return '<a class="color-blue" href="' + url2 + '" target="_blank">' + url + "</a>";
      });
      return response;
    },
    handleLinkClick(event) {
      if (event.target.tagName === "A" && event.target.href.includes("zalo.me/g/")) {
        event.preventDefault();
        this.$emit("clickLinkGroup", event.target.href);
      }
    },
    regexUrlFromText(text) {
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');
    },
  },
  mounted() {
    if (this.mentions && this.mentions !== "") {
      this.listMentions = JSON.parse(this.mentions).sort((a, b) => a.pos - b.pos);
      if (typeof this.listMentions === "string") {
        this.listMentions = [];
      }
    }
  },
};
</script>

<style scoped>
</style>
